import {
    FETCH_DRAWPOOL,
    FETCH_ROLLPOOL,
    FETCH_ROLLPOOLS,
    FETCH_WINNERSBYPAGE,
    FETCH_ATTENDEEWINNERS,
    FETCH_ADMIN_ROLLPOOLS,
    FETCH_ROLLPOOLBWLISTS,
    FETCH_DRAWPOOLBWLISTS
} from '../actions/luckydraw';


export const initialState = {
    isFetching: true,
    data: null
};

export const drawpool = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_DRAWPOOL}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_DRAWPOOL}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data ? action.payload.data.items : null,
            });
        default:
            return state;
    }
}

export const winners = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WINNERSBYPAGE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WINNERSBYPAGE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const attendeewinners = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEEWINNERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEEWINNERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}


//
export const rollpool = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ROLLPOOL}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ROLLPOOL}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data ? action.payload.data.items : null,
            });
        default:
            return state;
    }
}
export const rollpools = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ROLLPOOLS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ROLLPOOLS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const adminRollpools = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ADMIN_ROLLPOOLS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ADMIN_ROLLPOOLS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const rollpoolBwLists = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ROLLPOOLBWLISTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ROLLPOOLBWLISTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const drawpoolBwLists = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_DRAWPOOLBWLISTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_DRAWPOOLBWLISTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/luckydraw.js